module.exports = __webpack_public_path__ + "img/jm3.1fa2b1e6.png";